(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-img.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-img.js');

'use strict';

var _svs;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const CharityImg = _ref => {
  let charityProps = _ref.charityProps;
  const setCharity = useSetAtom(charityAtom);
  const handleClick = id => {
    setCharity(id);
    svs.utils.url.navigate("/lyckoplatsen/spela?charityId=".concat(id));
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleClick(charityProps.charityId);
    }
  };
  return React.createElement("div", {
    className: "lp-charity-logo-container elevation-100"
  }, React.createElement("img", {
    onClick: () => handleClick(charityProps.charityId),
    onKeyDown: e => handleKeyDown(e),
    tabIndex: 0,
    className: "charity-img",
    src: cdn + charityProps.logotypeId,
    alt: "".concat(charityProps.name, " logo")
  }));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  CharityImg
});

 })(window);